<template>
  <div class="box pl-5 pr-3 md:px-20 [counter-reset:step]">
    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      租金收費：
    </h3>
    <ul class="list-disc pl-5">
      <li>
        平日（星期一至星期五，及不包括公眾假期）租用車輛費用為
        <strong>港幣 90 元正</strong>
        ，租期為
        <strong>三小時</strong>
        。三小時後每小時
        <strong>港幣 200 元正。</strong>
      </li>
      <li>
        星期六、星期日及公眾假期：每次租用費用為
        <strong>港幣 35 元正</strong>
        ，租期為
        <strong>一小時</strong>
        。一小時後每小時
        <strong>港幣 200 元正</strong>
        。
      </li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      租用時段：
    </h3>
    <ul class="list-disc pl-5">
      <li>平日提供三個時段：9:00-12:00；12:30-15:30；16:00-19:00。</li>
      <li>
        星期六、星期日及公眾假期提供八個時段：
        <br />
        9:00-10:00；10:15-11:15；11:30-12:30；12:45-13:45；14:00-15:00；15:15-16:15；16:30-17:30；17:45-18:45。
      </li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      租用限制：
    </h3>
    <p>
      每位客戶於同一日內僅可租用
      <strong>一個時段</strong>
      ，並以車型為計算單位。
    </p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      租用資格：
    </h3>
    <ul class="list-disc pl-5">
      <li>本服務僅適用於有意購買 ICAUR 品牌車輛之客戶。</li>
      <li>
        客戶必須已繳付
        <strong>港幣 20,000 元訂金</strong>
        。
      </li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      租車按金：
    </h3>
    <ul class="list-disc pl-5">
      <li>
        客戶需繳付
        <strong>港幣 1,000 元</strong>
        作為按金。
      </li>
      <li>
        按金將扣除隧道費、逾時費用及交通違例罰款後，餘額於
        <strong>45日內</strong>
        退回(如有)。
      </li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      付款方式：
    </h3>
    <p>僅接受轉數快或銀行轉賬。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      預約逾時及處理安排：
    </h3>
    <ul class="list-disc pl-5">
      <li>
        如客人於預約時間後
        <strong>超過10分鐘</strong>
        仍未到達，本公司將視作客人自動放棄該預約。
      </li>
      <li>本公司有權將該時段轉讓予其他客人，且不作另行通知。</li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      逾時歸還：
    </h3>
    <ul class="list-disc pl-5">
      <li>如未能於約定租用時段內準時歸還車輛，本公司有權就逾期部分收取額外費用。</li>
      <li>
        逾期收費為
        <strong>每小時港幣 200 元正</strong>
        ，不足一小時亦按一小時計算，直至車輛實際歸還並完成交收之時為止。如未能於本公司營業時間內歸還車輛，本公司仍將按上述標準計算逾期費用，直至車輛實際歸還並完成交收之時為止。
      </li>
      <li>上述費用之收取不影響公司就客戶違反租約所享有之其他權利，包括但不限於追討損失及採取法律行動。</li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-22px] before:absolute"
    >
      緊急協助：
    </h3>
    <ul class="list-disc pl-5">
      <li>
        發生事故時，客戶可致電中國太平保險熱線
        <strong>2863 5525</strong>
        申請拖車服務。
      </li>
      <li>拖車服務僅限本公司租車客戶。</li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      一般查詢：
    </h3>
    <p>
      租車熱線：
      <strong>2448 8248</strong>
      售後服務熱線：
      <strong>2462 4621</strong>
    </p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      駕駛者資格：
    </h3>
    <ul class="list-disc pl-5">
      <li>
        租用人及實際駕駛者須年滿
        <strong>25歲</strong>
        ，並持有至少
        <strong>兩年有效駕駛執照</strong>
        。
      </li>
      <li>持有暫准駕駛執照（「P牌」）者不符合資格。</li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      授權駕駛者：
    </h3>
    <p>僅限客戶本人駕駛。如由公司名義落訂，必須由該公司名下NAR之名下董事駕駛。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      還車政策：
    </h3>
    <p>
      如車輛可正常行駛但未依規定歸還至指定租車中心（維修情況除外），本公司有權收取
      <strong>港幣 3,000 元</strong>
      拖車費。
    </p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      意外及損毀：
    </h3>
    <ul class="list-disc pl-5">
      <li>如車輛受損或涉及交通事故，客戶須立即通知本公司並提供現場照片作佐證。</li>
      <li>
        客戶須於事故發生後
        <strong>48小時內</strong>
        提交《租車事故報告》。
      </li>
      <li>
        本公司將向客戶收取
        <strong>港幣 40,000 元</strong>
        之免賠額，及因車輛零件折舊所產生的差額。如車輛維修時間超過五天，客戶需承擔維修期間租車的租金費用，最多不超過三個月。所付之餘額(如適用)將在事故處理完成後，分階段於
        <strong>45日</strong>
        內退還予租客。
      </li>
      <li>如在處理過程中出現任何爭議，本公司保留最終決定權。</li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      清潔責任：
    </h3>
    <p>
      車輛必須保持清潔，嚴禁吸煙。如因吸煙、食物殘渣或寵物造成污染，客戶需支付
      <strong>港幣 1,000</strong>
      至
      <strong>2,000 元</strong>
      清潔費（視乎實際情況）。
    </p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      駕駛限制：
    </h3>
    <p>租車期間嚴禁駛入禁區、進行高風險駕駛行為或作任何非法用途。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      交通法規：
    </h3>
    <p>駕駛者必須遵守《道路交通條例》。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      罰款及責任：
    </h3>
    <p>因交通違規導致之罰款、扣分、事故或法律責任由客戶及駕駛者自行承擔。本公司概不負責。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      車匙政策：
    </h3>
    <ul class="list-disc pl-5">
      <li>租車期間僅提供一把車匙。</li>
      <li>
        遺失車匙，本公司將收取
        <strong>港幣 1,500 元補發費用</strong>
        。
      </li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      GPS系統：
    </h3>
    <p>車輛配備 GPS 定位系統。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      禁止事項：
    </h3>
    <p>嚴禁酒後或藥後駕駛。本公司保留追討損失及採取法律行動。</p>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      車輛安全：
    </h3>
    <ul class="list-disc pl-5">
      <li>客戶須妥善保管車輛並確保車門上鎖。</li>
      <li>車輛安全責任由客戶全權承擔，包括防止失竊、損毀或未經授權使用。</li>
    </ul>

    <h3
      class="[counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#000] before:ml-[-30px] before:absolute"
    >
      個人資料：
    </h3>
    <p>客戶所提供之個人資料僅用於租車相關用途（並按適用法律作合理保護）。</p>
  </div>
</template>

<script>
export default {
  name: 'RentReg',
}
</script>
<style lang="scss" scoped>
// .contaier>.el-dialog__body {
//   padding: 30px 40px !important;
// }

.box {
  h3 {
    color: #111;
    margin-top: 24px;
    margin-bottom: 2px;
    font-size: 20px;
    font-weight: 600;
    white-space: normal;
    display: inline-block;
  }

  p {
    padding-left: 5px;
  }

  p,
  li {
    color: #333;
    font-size: 16px;
    line-height: 30px;
  }
}
</style>
